import React from 'react';
import { FormProps as RFFFormProps, Form as ReactFinalForm } from 'react-final-form';
import { RffSchema } from '../../lib/ReactFinalForm';
import { StateMutator } from './RffMutators/StateMutator';

interface FormProps<FormValues> extends RFFFormProps<FormValues> {
    schema?: RffSchema<FormValues>;
}

const Form: <FormValues>(props: FormProps<FormValues>) => React.ReactElement = <FormValues,>({
    mutators,
    schema,
    ...props
}: FormProps<FormValues>) => {
    const schemaProps: Partial<FormProps<FormValues>> = {};
    if (schema?.initialValues && !props?.initialValues) {
        schemaProps.initialValues = schema.initialValues;
    }
    if (schema?.validationSchema && !props?.validate) {
        schemaProps.validate = schema.validate;
    }
    return <ReactFinalForm mutators={{ ...new StateMutator<FormValues>(), ...mutators }} {...props} {...schemaProps} />;
};
export default Form;
